/**
 * Validate full name (Vietnamese)
 * @param {string} name - Full name
 * @returns {Object} { valid: boolean, error: string }
 */
export const validateFullName = (name) => {
    if (!name || name.trim().length < 5) {
        return { valid: false, error: 'Họ tên phải có ít nhất 5 ký tự' };
    }
    const words = name.trim().split(/\s+/);
    if (words.length < 2) {
        return { valid: false, error: 'Họ tên phải có ít nhất 2 từ' };
    }
    return { valid: true, error: '' };
};

/**
 * Validate ID number (CCCD/CMT)
 * @param {string} idNumber - ID number
 * @returns {Object} { valid: boolean, error: string }
 */
export const validateIdNumber = (idNumber) => {
    const cleaned = idNumber.replace(/\s/g, '');
    const regex = /^[0-9]{9}$|^[0-9]{12}$/;
    if (!regex.test(cleaned)) {
        return { valid: false, error: 'Số CCCD phải có 9 hoặc 12 chữ số' };
    }
    return { valid: true, error: '' };
};

/**
 * Validate Vietnamese phone number
 * @param {string} phone - Phone number
 * @returns {Object} { valid: boolean, error: string }
 */
export const validatePhoneNumber = (phone) => {
    const cleaned = phone.replace(/\s/g, '');
    const regex = /^0[0-9]{9,10}$/;
    if (!regex.test(cleaned)) {
        return { valid: false, error: 'Số điện thoại phải bắt đầu bằng 0 và có 10-11 chữ số' };
    }
    return { valid: true, error: '' };
};

/**
 * Validate email
 * @param {string} email - Email address
 * @returns {Object} { valid: boolean, error: string }
 */
export const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!regex.test(email)) {
        return { valid: false, error: 'Email không hợp lệ' };
    }
    return { valid: true, error: '' };
};

/**
 * Validate employee code
 * @param {string} code - Employee code
 * @returns {Object} { valid: boolean, error: string }
 */
export const validateEmployeeCode = (code) => {
    if (!code || code.trim().length < 4) {
        return { valid: false, error: 'Mã nhân viên phải có ít nhất 4 ký tự' };
    }
    return { valid: true, error: '' };
};

/**
 * Validate date of birth (DD/MM/YYYY)
 * @param {string} date - Date string
 * @returns {Object} { valid: boolean, error: string }
 */
export const validateDateOfBirth = (date) => {
    if (!date) return { valid: true, error: '' }; // Optional field

    const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
    const match = date.match(regex);

    if (!match) {
        return { valid: false, error: 'Ngày sinh phải có định dạng DD/MM/YYYY' };
    }

    const day = parseInt(match[1], 10);
    const month = parseInt(match[2], 10);
    const year = parseInt(match[3], 10);

    if (month < 1 || month > 12) {
        return { valid: false, error: 'Tháng không hợp lệ' };
    }

    if (day < 1 || day > 31) {
        return { valid: false, error: 'Ngày không hợp lệ' };
    }

    if (year < 1900 || year > new Date().getFullYear()) {
        return { valid: false, error: 'Năm không hợp lệ' };
    }

    return { valid: true, error: '' };
};

/**
 * Validate OTP (6 digits)
 * @param {string} otp - OTP code
 * @returns {Object} { valid: boolean, error: string }
 */
export const validateOTP = (otp) => {
    const regex = /^[0-9]{6}$/;
    if (!regex.test(otp)) {
        return { valid: false, error: 'Mã OTP phải có 6 chữ số' };
    }
    return { valid: true, error: '' };
};
